export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"m7.5 2-1 11h4l-1 9 8-13h-5.999L15.5 2z\"/>"
};